import { createSelector } from 'reselect';
import { IRootState, Selector } from '../rootReducer';
import { IBusinessInfo } from './types';

const getBusinessInfo = (state: IRootState): IBusinessInfo =>
  state.businessInfo;

const isShowClosingScene: Selector<boolean> = createSelector(
  getBusinessInfo,
  (businessInfo) => businessInfo.showClosingScene,
);

export { getBusinessInfo, isShowClosingScene };
